// extracted by mini-css-extract-plugin
export default {"productGrid":"N1-z","centerLink":"O1-z","productSection":"P1-z","item":"Q1-z","ctaButton":"R1-z"};